import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import TaskUpdation from "./taskUpdation";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function TaskUpdateModal({ show, handleClose, rowData, type }) {

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="md"
            keepMounted
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    backgroundColor: '#fdfdfd',
                    boxShadow: 6,
                    mt: { xs: 2, sm: 4 },
                    mx: { xs: 1, sm: 4 },
                    width: { xs: "calc(100% - 16px)", sm: "calc(100% - 64px)" },
                    alignSelf: 'flex-start',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'var(--primary)',
                    color: '#fff',
                    px: { xs: 2, sm: 3 },
                    py: 1,
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                }}
            >
                <DialogTitle sx={{ m: 0, p: 0, fontSize: '1.2rem' }}>Lead Update & History</DialogTitle>
                <IconButton onClick={() => handleClose()} sx={{ color: '#fff' }}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent dividers sx={{ px: { xs: 1.5, sm: 3 } }}>
                <TaskUpdation rowData={rowData} show={show} handleClose={handleClose} updationType={type} />
            </DialogContent>

        </Dialog>
    );
}
